// Compiled at 2026-10-07T06:21:14.844Z
// Auto-generated by Lowgile
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Toolbox, Toolbox as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { ResourceDefinition } from "@lg/shared";

export class $Resources {
    static readonly Logo: ResourceDefinition<'client', 'downloadable'> = {
        resourceType: 'image/svg+xml',
        mimeType: 'image/svg+xml',
        fileName: 'logo_esmo_org.svg',
        relativeUrl: '/master/Toolbox/Toolbox.Logo/logo_esmo_org.svg',
        get absoluteUrl() { return `${System.$Config.Environment.publicUrl}/master/Toolbox/Toolbox.Logo/logo_esmo_org.svg` },


    };
}
